module.exports = __webpack_public_path__ + "static/media/briefcase-medical.0cb14ceb.svg";